<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline"
          >{{ originalItem ? "Editar" : "Nuevo" }} producto</span
        >
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="5" md="5">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    accept="image/png, image/jpeg"
                    show-size
                    v-show="false"
                    counter="3"
                    hint="Máximo 3 imágenes"
                    persistent-hint
                    multiple
                    :disabled="loading"
                    @change="selectedFile"
                    id="fileInput"
                    label="Seleccionar imágenes"
                    rounded
                    filled
                  ></v-file-input>
                  <v-btn
                    block
                    :disabled="sourceFiles.length >= 3"
                    @click="addFile"
                    style="border-radius: 0 !important"
                  >
                    <v-icon style="color: gray !important" class="mr-5">
                      fas fa-images
                    </v-icon>
                    Agregar imágenes
                  </v-btn>
                </v-col>

                <v-col class="pa-0" cols="12" sm="12" md="12">
                  <v-row>
                    <v-col
                      v-for="(item, index) of getImages"
                      :key="index"
                      cols="12"
                      sm="4"
                      md="4"
                    >
                      <v-icon
                        @click="deleteImage(item)"
                        class="delete-image"
                        style="font-size: 22px!important"
                        >fas fa-trash-alt</v-icon
                      >
                      <v-img class="product-image" :src="item"></v-img>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="product.name"
                    label="Nombre del producto"
                    :loading="loading"
                    clearable
                    autofocus
                    rounded
                    filled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model.number="product.price"
                    label="Precio"
                    :loading="loading"
                    rounded
                    filled
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pa-0" cols="12" sm="12" md="12">
                  <v-textarea
                    :value="product.description"
                    label="Descripción del producto"
                    :loading="loading"
                    clearable
                    class="pa-3"
                    v-model="product.description"
                    :rows="4"
                    rounded
                    filled
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-col>

            <v-col class="pr-3" cols="12" sm="7" md="7">
              <v-row>
                <v-col
                  style="max-height: 410px; overflow-y: auto"
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <span>Características del producto</span>
                  <hr class="title-hr" />
                  <v-select
                    :items="characteristics"
                    v-if="!originalItem"
                    item-text="name"
                    item-value=".key"
                    :loading="loading"
                    @change="updateItems"
                    label="Seleccione un conjunto de características"
                    rounded
                    class="mt-3"
                    filled
                  ></v-select>

                  <v-row
                    v-for="(item, index) of product.characteristics"
                    :key="index"
                  >
                    <v-col cols="5" sm="5" md="5">
                      <v-text-field
                        v-model="item.name"
                        label="Nombre"
                        :loading="loading"
                        clearable
                        autofocus
                        rounded
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        v-model="item.value"
                        label="Descripción"
                        v-on:keyup.enter="addCharacteristic"
                        :loading="loading"
                        clearable
                        rounded
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      v-if="product.characteristics.length > 1"
                      cols="1"
                      sm="1"
                      md=""
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            @click="removeCharacteristic(index)"
                            v-on="on"
                            style="cursor: pointer"
                            class="mt-5"
                          >
                            fas fa-trash-alt
                          </v-icon>
                        </template>
                        <span>Eliminar característica</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row class="mr-5" justify="end">
                    <v-btn
                      class="mt-3 mr-5"
                      style="border-radius: 0 !important"
                      @click="addCharacteristic"
                      :loading="loading"
                    >
                      <v-icon left> fas fa-plus </v-icon>
                      Agregar característica
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="end">
                <v-btn
                  :loading="loading"
                  @click="originalItem ? update() : save()"
                  color="btn-color"
                  >Guardar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";

export default {
  name: "add-product",
  props: ["originalItem"],
  data() {
    return {
      product: {
        name: "",
        price: "",
        description: "",
        images: [],
        characteristics: [
          { name: "", value: "" },
          { name: "", value: "" },
        ],
      },
      characteristics: [],
      snackbarText: "",
      snackbar: false,
      loading: false,
      files: [],
      progress: 0,
      sourceFiles: [],
    };
  },
  computed: {
    ...mapState(["user", "userDoc", "groupId"]),
    getImages() {
      if (this.sourceFiles.length > 0)
        return [
          ...this.product.images.map((item) => {
            return item.url;
          }),
          ...this.sourceFiles,
        ];
      else
        return this.product.images.map((item) => {
          return item.url;
        });
    },
  },

  methods: {
    addCharacteristic() {
      this.product.characteristics.push({
        name: "",
        value: "",
      });
    },
    removeCharacteristic(index) {
      this.product.characteristics.splice(index, 1);
    },
    updateItems(id) {
      this.product.characteristics = [];
      let result = this.characteristics.find((item) => item[".key"] == id);
      result.items.forEach((item) => {
        this.product.characteristics.push({
          name: item,
          value: "",
        });
      });
    },
    deleteImage(item) {
      if (item.includes("data:image")) {
        let index = this.sourceFiles.indexOf(item);
        this.files.splice(index, 1);
        this.sourceFiles.splice(index, 1);
      } else {
        this.product.images = this.product.images.filter((url) => url != item);
      }
    },
    addFile() {
      document.getElementById("fileInput").click();
    },
    selectedFile(e) {
      if (this.product.images.length + this.sourceFiles.length + e.length > 3) {
        this.snackbarText = "Solo se permiten 3 imágenes por producto.";
        this.snackbar = true;
        return;
      } else {
        this.files = this.files.concat(e);
        this.sourceFiles = [];
        for (let i = 0; i < this.files.length; i++) {
          var reader = new FileReader();
          const image = this.files[i];
          reader.onload = (e) => {
            this.src = e.target.result;
            this.sourceFiles.push(e.target.result);
          };
          reader.readAsDataURL(image);
        }
      }
    },

    async save() {
      if (this.product.name) {
        this.loading = true;
        let images = [];
        this.product.characteristics = this.product.characteristics.filter(
          (item) => item.name && item.value
        );

        db.collection("products")
          .add({
            name: this.product.name,
            description: this.product.description,
            characteristics: this.product.characteristics,
            price: this.product.price,
            createdAt: new Date(),
            createdBy: this.user.uid,
            groupId: this.groupId,
          })
          .then(async (ref) => {
            for (let i = 0; i < this.files.length; i++) {
              const file = this.files[i];
              let url = await this.uploadImages(ref.id, file);
              let filename = `${Date.now()}_${Math.floor(
                Math.random() * (10000000000 - 10000000) + 10000000
              )}_${Math.floor(
                Math.random() * (10000000000 - 10000000) + 10000000
              )}`;
              images.push({
                filename,
                url,
              });
            }
            await db.collection("products").doc(ref.id).update({ images });
            this.loading = false;
            this.$emit("success");
          })
          .catch((err) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      }
    },

    update() {
      if (this.product.name) {
        this.loading = true;
        let images = [];
        this.product.characteristics = this.product.characteristics.filter(
          (item) => item.name && item.value
        );

        db.collection("products")
          .doc(this.originalItem[".key"])
          .update({
            name: this.product.name,
            description: this.product.description,
            characteristics: this.product.characteristics,
            price: this.product.price,
            modifiedAt: new Date(),
            modifiedBY: this.user.uid,
          })
          .then(async (response) => {
            for (let i = 0; i < this.files.length; i++) {
              const file = this.files[i];
              let url = await this.uploadImages(
                this.originalItem[".key"],
                file
              );
              let filename = `${Date.now()}_${Math.floor(
                Math.random() * (10000000000 - 10000000) + 10000000
              )}_${Math.floor(
                Math.random() * (10000000000 - 10000000) + 10000000
              )}`;

              images.push({
                filename,
                url,
              });
            }

            await db
              .collection("products")
              .doc(this.originalItem[".key"])
              .update({
                images: this.product.images.concat(images),
              });

            this.loading = false;
            this.$emit("success");
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      }
    },

    uploadImages(productId, file) {
      return new Promise((resolve, reject) => {
        let extension = file.type.split("/").pop();
        let dataName = `${Math.round(
          Math.random() * (10000000000000 - 100000000) + 100000000
        )}_${Math.round(
          Math.random() * (10000000000000 - 100000000) + 100000000
        )}.${extension}`;

        var uploadTask = fb
          .app()
          .storage("gs://beanage-products")
          .ref()
          .child(`${this.groupId}/${productId}/${dataName}`)
          .put(file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            this.progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
            // console.log(error);
          },
          function () {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              resolve(downloadURL);
            });
          }
        );
      });
    },
  },
  async mounted() {
    await this.$binding(
      "characteristics",
      db.collection("characteristics").where("groupId", "==", this.groupId)
    );

    if (this.originalItem) {
      this.product = Object.assign({}, this.originalItem);
      this.product.characteristics =
        this.product.characteristics.length == 0
          ? [
              { name: "", value: "" },
              { name: "", value: "" },
            ]
          : this.product.characteristics;
    }
  },
};
</script>

<style>
.product-image {
  cursor: pointer;
  max-width: 140px;
  max-height: 90px;
  min-width: 140px;
  min-height: 90px;
  height: 90px;
  border-radius: 10px;
  object-fit: fill;
}
.add-image {
  width: 50px;
  height: 50px;
  background-color: #f4ede4;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 15px;
}
.delete-image {
  position: relative;
  z-index: 1000;
  color: white;
  top: 30px;
  right: 10px;
  color: red!important;
  font-size: 20px!important;
  font-weight: bold;
  float: right;
  cursor: pointer;
  font-weight: bold;
}
.add-icon {
  font-size: 20px !important;
  cursor: pointer;
  background-color: rgb(135, 120, 192);
  padding: 20px;
  color: white !important;
  border-radius: 70px;
}
</style>